import 'babel-polyfill';
import './compatibility';

window._ = require('lodash');
window.swal = require('sweetalert2');
window.moment = require('moment');

import 'dragster';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');
require('bootstrap-datepicker');
require('jquery-slimscroll');
require('admin-lte/dist/js/adminlte');
require('devbridge-autocomplete');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

import axios from 'axios';
import Vue from 'vue';
Vue.config.productionTip = false;
window.Vue = Vue;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// Imported rather than required. axios ships both a CommonJS and an ES module
// build, and webpack gives require() the first and `import` the second: two
// separate instances with separate interceptor and defaults registries. Every
// component reaches axios through `import`, so anything configured on the
// required copy applied to nothing, which silently included the headers below
// and the failure reporting further down.
window.axios = axios;

window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Report a request the application could not complete.
 *
 * Without this, each component decided on its own whether to mention a failure
 * and most said nothing: a 403 or a 500 produced an unhandled rejection, an
 * empty screen and a clean console, which is indistinguishable from a screen
 * that simply has no data. Two faults found by crawling the application had
 * exactly that appearance, and it is what a client reports as "the page is
 * blank", which carries nothing useful back to whoever has to fix it.
 *
 * This reports and then steps aside. The rejection is passed on unchanged, so
 * every component that already handles its own failures keeps doing so.
 *
 * Statuses a component is expected to act on, such as 404 and a 422 validation
 * response, are logged but not announced here, because the screen that asked for
 * them has a better answer than this does.
 */
const requestFailureMessages = {
    401: 'Your session has expired. Please sign in again.',
    419: 'Your session has expired. Please sign in again.',
    403: 'You do not have permission to view that.',
    429: 'Too many requests. Please wait a moment and try again.',
};

function requestFailureMessage(error) {
    if (!error.response) {
        return 'Could not reach the server. Please check your connection.';
    }

    if (requestFailureMessages[error.response.status]) {
        return requestFailureMessages[error.response.status];
    }

    return error.response.status >= 500 ? 'Something went wrong. Please try again.' : null;
}

window.axios.interceptors.response.use(
    response => response,
    (error) => {
        const config = error.config || {};
        const method = (config.method || 'get').toUpperCase();
        const status = error.response ? error.response.status : 'no response';

        console.error(`Request failed: ${method} ${config.url} -> ${status}`);

        const message = requestFailureMessage(error);

        // One dialog at a time. A screen that fires a request per row would
        // otherwise stack a dialog per row on top of the same underlying fault.
        if (message && !window.swal.isVisible()) {
            window.swal('Error', message, 'error');
        }

        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

import Pusher from 'pusher-js';

window.Pusher = Pusher;

/**
 * Broadcasting is optional. The test environment runs the "null" broadcast
 * driver and ships no Reverb credentials, so window.Laravel.reverb.key is
 * empty there. Echo's own null broadcaster keeps window.Echo a working
 * object in that case, which means every Echo.private(...).listen(...) call
 * site stays safe rather than throwing and taking the whole SPA down with it.
 */
const reverb = window.Laravel.reverb;

window.Echo = reverb.key
    ? new Echo({
        broadcaster: 'reverb',
        key: reverb.key,
        wsHost: reverb.host,
        wsPort: reverb.port,
        wssPort: reverb.port,
        forceTLS: reverb.scheme === 'https',
        enabledTransports: ['ws', 'wss'],
    })
    : new Echo({ broadcaster: 'null' });

